/* SPN Video: laedt Loop-Videos erst kurz vor dem Sichtbarwerden und nimmt am Handy die kleinere Fassung. */
(function () {
  function start() {
    var vids = document.querySelectorAll('video.spn-video[data-gross]:not([data-spn-bereit])');
    if (!vids.length) return;
    var klein = window.matchMedia('(max-width: 749px)').matches;
    var beobachten = 'IntersectionObserver' in window;
    var io = beobachten
      ? new IntersectionObserver(function (eintraege) {
          eintraege.forEach(function (e) {
            var v = e.target;
            if (e.isIntersecting) {
              if (!v.getAttribute('src')) {
                var q = klein ? v.dataset.klein : v.dataset.gross;
                if (q) v.setAttribute('src', q);
              }
              var p = v.play();
              if (p && p.catch) p.catch(function () {});
            } else if (!v.paused) {
              v.pause();
            }
          });
        }, { rootMargin: '200px 0px' })
      : null;
    Array.prototype.forEach.call(vids, function (v) {
      v.setAttribute('data-spn-bereit', '1');
      if (io) {
        io.observe(v);
      } else {
        v.setAttribute('src', klein ? v.dataset.klein : v.dataset.gross);
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
